export const ADD_VENUE= 'ADD_VENUE'
export const ADD_VENUE_SUCCESS= 'ADD_VENUE_SUCCESS'
export const ADD_VENUE_ERROR='ADD_VENUE_ERROR'

export const AddVenue= (data) => ({
    type: ADD_VENUE,
    payload: data
})